module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_47.22e9abb0.jpg";